import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=1486a826&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=ts&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1486a826",
  null
  
)

export default component.exports